import { useSearchClient } from '@lib/database/customSearchClient'
import { getAlgoliaSearchIndex } from '@lib/database/getAlgoliaSearchIndex'
import debounce from 'lodash/debounce'
import { useCallback } from 'react'

const algoliaIndex = getAlgoliaSearchIndex('trials-by-site-locations')

export function useSearchFacetValues({
  attribute,
  setResults,
}: {
  attribute: string
  setResults: (values: string[]) => void
}) {
  const searchClient = useSearchClient()

  return useCallback(
    debounce((query: string) => {
      if (!query) {
        return
      }

      searchClient.searchForFacetValues!([
        {
          indexName: algoliaIndex,
          params: {
            facetName: attribute,
            facetQuery: query,
          },
        },
      ]).then((responses) => {
        const res = responses[0]
        setResults(res?.facetHits.map((item) => item.value) ?? [])
      })
    }, 250),
    [attribute, setResults, searchClient],
  )
}
